module.exports = __webpack_public_path__ + "media/customizations/lakenona/logo-new-6ae84f1f3bd304c397c84757b05298cc.png";